import { _axios } from "../../../Utils/Axios/axios";

export const sendAnswersOfQuestionsService = async (
  userToken: string,
  questions: string,
  answers: string,
  quizId: string | number,
  count: number
) => {
  const formData = new FormData();
  formData.append("answers", answers);
  formData.append("questions", questions);
  formData.append("quiz_id", String(quizId));
  formData.append("count", String(count));

  return _axios.post("/quiz_correction", formData, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
